import { buildUrl, handleResponse } from "./auth";

const jsonHeaders = { "Content-Type": "application/json" };

export const getAdminTokens = (params) => {
  const take = params?.take ? `?take=${params.take}` : "";
  return fetch(buildUrl(`/api/admin/tokens${take}`), {
    credentials: "include",
  }).then(handleResponse);
};

export const revokeAdminToken = (tokenId, payload) =>
  fetch(buildUrl(`/api/admin/tokens/${tokenId}/revoke`), {
    method: "POST",
    headers: jsonHeaders,
    body: JSON.stringify(payload ?? {}),
    credentials: "include",
  }).then(handleResponse);

export const reissueAdminBookingToken = (bookingId) =>
  fetch(buildUrl(`/api/admin/bookings/${bookingId}/token/reissue`), {
    method: "POST",
    credentials: "include",
  }).then(handleResponse);

const adminTokensApi = {
  getAdminTokens,
  revokeAdminToken,
  reissueAdminBookingToken,
};

export default adminTokensApi;
